(() => {
  const selector = {
    slider: '.benefits__content--slider',
  };
  const slider = document.querySelector(selector.slider);

  if (slider) {
    const variableWidth = slider.dataset.variableWidth === "true" ? true : false;
    const mobileSlidesToShow = variableWidth ? Math.round(+slider.dataset.slidesToScrollMobile) : +slider.dataset.slidesToScrollMobile;
    const slickSettings = {
      infinite: true,
      dots: false,
      arrows: false,
      cssEase: 'linear',
      slidesToScroll: +slider.dataset.slidesToScroll,
      slidesToShow: +slider.dataset.slidesToShow,
      autoplay: slider.dataset.autoPlay === "true" ? true : false,
      autoplaySpeed: +slider.dataset.playSpeed,
      speed: +slider.dataset.sliderSpeed,
      swipeToSlide: slider.dataset.sliderInfinityLoop === "true" ? true : false,
      centerMode: slider.dataset.sliderInfinityLoop === "true" ? true : false,
      focusOnSelect: slider.dataset.sliderInfinityLoop === "true" ? true : false,
      variableWidth: variableWidth,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: mobileSlidesToShow,
            slidesToScroll: +slider.dataset.slidesToScrollMobile
          }
        }
      ]
    };

    $(slider).slick(slickSettings);
  }
})();
